import { APIMain } from "@/apiRequester";
import { ApiConstant } from "../const";
import { NEXT_PUBLIC_UPLOAD_URL } from "@/const/env.const";
import { CategoryTypeUploadEnum, IUploadFile } from "@/models";

// export const uploadFileGetUrlImg = (body: FormData) => {
//   return APIMain.post<IUploadFile[]>(
//     ApiConstant.UPLOAD_API.POST_UPLOAD_IMG,
//     body,
//     {
//       baseUrl: NEXT_PUBLIC_UPLOAD_URL,
//       headers: { "Content-Type": "multipart/form-data" },
//     }
//   );
// };

export const uploadFile = (
  body: FormData,
  categorytype: CategoryTypeUploadEnum,
  ownerid: string = ""
) => {
  return APIMain.post<IUploadFile>(
    ApiConstant.UPLOAD_API.POST_UPLOAD_FILE,
    body,
    {
      baseUrl: NEXT_PUBLIC_UPLOAD_URL,
      headers: {
        categorytype: categorytype,
        ownerid: ownerid,
      },
    }
  );
};
export const deleteFile = (
  id: string,
  categoryType: CategoryTypeUploadEnum
) => {
  return APIMain.delete<boolean>(
    ApiConstant.UPLOAD_API.POST_UPLOAD_FILE + "/" + id,
    {
      baseUrl: NEXT_PUBLIC_UPLOAD_URL,
    }
  );
};
